import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfiguration } from "./msalConfiguration";

export const msalInstance = new PublicClientApplication(msalConfiguration);
